const PLY_APP_URL = process.env.VUE_APP_APP_URL;

const liteUserSharedParams = (requestAccess: unknown) => ({
	title: 'Your admin needs to take action for you to use this feature',
	description:
		'As a lite member you can run only features that are shared with the workspace. To use this feature you will need to be at least a standard member.',
	primaryButtonText: 'Request access',
	onPrimaryClick: requestAccess,
});

const liteToStandardParams = (requestAccess: unknown) => ({
	title: 'Your admin needs to take action for you to use this feature',
	description: 'This feature requires you to be a standard member in this workspace. You are a lite member',
	primaryButtonText: 'Request access',
	onPrimaryClick: requestAccess,
});

const liteToPremiumParams = (requestAccess: unknown) => ({
	title: 'Your admin needs to take action for you to use this feature',
	description: 'This feature requires you to be a premium member in this workspace. You are a lite member',
	primaryButtonText: 'Request access',
	onPrimaryClick: requestAccess,
});

const standardToPremiumParams = (requestAccess: unknown) => ({
	title: 'Your admin needs to take action for you to use this feature',
	description: 'This feature requires you to be a premium member in this workspace. You are a standard member',
	primaryButtonText: 'Request access',
	onPrimaryClick: requestAccess,
});

const noTasksNotAdmin = () => ({
	title: 'Your workspace is out of tasks or credits.',
	description: 'Contact an admin',
	primaryButtonText: 'Got it',
});

const noTasksAdmin = () => ({
	title: 'Your workspace is out of tasks or credits.',
	description: 'Upgrade the relevant plan or add-on to continue using your features.',
	secondaryButtonText: 'See usage',
	primaryButtonText: 'Upgrade',
	onPrimaryClick: () => {
		window.open(`${PLY_APP_URL}customize-plan`, '_blank');
	},
	onSecondaryClick: () => {
		window.open(`${PLY_APP_URL}usage`, '_blank');
	},
});

const capabilityRestrictedNotAdmin = () => ({
	title: 'This capability is not included in your workspace plan',
	description: 'Contact your admin to upgrade your plan',
	primaryButtonText: 'Got it',
});

const capabilityRestrictedAdminFromExt = () => ({
	title: 'This capability is not included in your workspace plan',
	description: 'Upgrade the relevant plan or add-on to continue using your features.',
	primaryButtonText: 'Upgrade',
	onPrimaryClick: () => {
		window.open(`${PLY_APP_URL}customize-plan`, '_blank');
	},
});

const customerOutOfTasks = () => ({
	title: 'Looks like there was a problem running this portal.',
	description: 'The owner has been notified.',
	primaryButtonText: 'Got it',
});

// values are coming from the extension as well so do not change the numbers
export enum Modes {
	liteToStandard = 1,
	liteToPremium = 2,
	standardToPremium = 3,
	noTasksNotAdmin = 4,
	noTasksAdmin = 5,
	capabilityRestrictedNotAdmin = 6,
	capabilityRestrictedAdminFromExt = 7,
	customerOutOfTasks = 8,
	liteSharedUser = 9,
}

export const modeToParamsMap = (requestAccess?: unknown) => ({
	[Modes.liteToStandard]: liteToStandardParams(requestAccess),
	[Modes.liteToPremium]: liteToPremiumParams(requestAccess),
	[Modes.standardToPremium]: standardToPremiumParams(requestAccess),
	[Modes.noTasksNotAdmin]: noTasksNotAdmin(),
	[Modes.noTasksAdmin]: noTasksAdmin(),
	[Modes.capabilityRestrictedNotAdmin]: capabilityRestrictedNotAdmin(),
	[Modes.capabilityRestrictedAdminFromExt]: capabilityRestrictedAdminFromExt(),
	[Modes.customerOutOfTasks]: customerOutOfTasks(),
	[Modes.liteSharedUser]: liteUserSharedParams(requestAccess),
});
